import type { ReactNode } from 'react';

export const symbol_potted_plant: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M317-140h326l48-190H269l48 190Zm0 60q-20 0-36.29-12.54Q264.43-105.08 259-125l-52-205h546l-52 205q-5.43 19.92-21.71 32.46Q663-80 643-80H317ZM180-390h600v-100H180v100Zm300-251q5-88 67-150t149-83q4.23-1 7.62-.5 3.38.5 6.38 3.5t4 6.54q1 3.53 0 7.46-17 79-71 138t-133 73.74V-550h300q12.75 0 21.38 8.62Q840-532.75 840-520v130q0 24.75-17.62 42.37Q804.75-330 780-330H180q-24.75 0-42.37-17.63Q120-365.25 120-390v-130q0-12.75 8.63-21.38Q137.25-550 150-550h300v-95q-79-15-133-74t-71-138q-1-3.93 0-7.46 1-3.54 4-6.54t6.38-4q3.39-1 7.62 0 88 20 150 83t66 151Z"
		/>
	</svg>
);
